import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _slicedToArray from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React, { useEffect, useState } from 'react';
import { Typography, Col, Image, Form, RichTextRenderer, Section, InPageNav } from '@miro-site/ui-design-system';
import { Cta } from '@miro-site/components';
import { Container } from '@miro-site/ui-core';
import { styled } from '@miro-site/ui-styled-engine';
import { getHeadingsFromDocumentBlock, BLOCKS } from '@miro-site/utils-rich-text';
import FooterSection from '../../seo-templates/shared/FooterSection';
import ReadMore from '../../seo-templates/shared/ReadMore';
import OtherSolutions from '../../seo-templates/shared/OtherSolutions';
import BreadCrumb from '../../seo-templates/shared/BreadCrumb';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
var BreadCrumbContainer = styled('div', {
  span: {
    top: '0'
  }
});

var SeoInfoPage = function SeoInfoPage(_ref) {
  var body = _ref.body,
      _ref$navigation = _ref.navigation,
      navigation = _ref$navigation === void 0 ? {} : _ref$navigation,
      heroSection = _ref.heroSection,
      emailSection = _ref.emailSection,
      readMoreSection = _ref.readMoreSection,
      othersSection = _ref.othersSection,
      footerSection = _ref.footerSection;
  var _navigation$navItems = navigation.navItems,
      navItems = _navigation$navItems === void 0 ? [] : _navigation$navItems;

  var _getHeadingsFromDocum = getHeadingsFromDocumentBlock(body[0], BLOCKS.HEADING_2),
      _getHeadingsFromDocum2 = _slicedToArray(_getHeadingsFromDocum, 1),
      parsedFirstBody = _getHeadingsFromDocum2[0];

  var _useState = useState({
    content: body[0],
    title: parsedFirstBody === null || parsedFirstBody === void 0 ? void 0 : parsedFirstBody.heading,
    id: parsedFirstBody === null || parsedFirstBody === void 0 ? void 0 : parsedFirstBody.id
  }),
      currentNavItem = _useState[0],
      setCurrentNavItem = _useState[1];

  var _useState2 = useState(''),
      currentHash = _useState2[0],
      setCurrentHash = _useState2[1];

  var _useState3 = useState(''),
      emailField = _useState3[0],
      setEmailField = _useState3[1];

  var signupUrl = "/signup?email=".concat(emailField);

  var getAccordionItems = function getAccordionItems() {
    return body.map(function (content) {
      var _getHeadingsFromDocum3 = getHeadingsFromDocumentBlock(content, BLOCKS.HEADING_2),
          _getHeadingsFromDocum4 = _slicedToArray(_getHeadingsFromDocum3, 1),
          mainHeading = _getHeadingsFromDocum4[0];

      var subHeadings = getHeadingsFromDocumentBlock(content);
      return {
        title: mainHeading.heading,
        id: mainHeading.id,
        content: content,
        options: subHeadings.map(function (heading) {
          return {
            title: heading.heading,
            href: "#".concat(heading.id),
            active: currentHash == heading.id,
            onClick: function onClick() {
              setCurrentNavItem({
                content: content,
                title: heading.heading,
                id: mainHeading.id
              });
            }
          };
        })
      };
    });
  };

  var getSidebarNav = function getSidebarNav() {
    if (!(body !== null && body !== void 0 && body.length)) {
      return null;
    }

    var items = getAccordionItems();

    if (navItems !== null && navItems !== void 0 && navItems.length) {
      items = items.concat(navItems.filter(function (item) {
        return !!(item.href && item.title);
      }));
    }

    var mobileSelect = {
      onChange: function onChange(id) {
        var item = items.find(function (item) {
          return item.id === id;
        });
        setCurrentNavItem({
          content: item["content"],
          title: item.title,
          id: id
        });
      },
      value: currentNavItem.id
    };
    return /*#__PURE__*/_jsx(InPageNav, {
      type: "accordion",
      items: items,
      title: navigation.title,
      defaultActiveKey: currentNavItem === null || currentNavItem === void 0 ? void 0 : currentNavItem.title,
      mobileSelect: mobileSelect
    });
  };

  useEffect(function () {
    var setHashValue = function setHashValue(hash) {
      return setCurrentHash(hash.replace('#', ''));
    };

    setHashValue(window.location.hash);

    var hashChanged = function hashChanged() {
      setHashValue(window.location.hash);
    };

    window.addEventListener('hashchange', hashChanged);
    return function () {
      window.removeEventListener('hashchange', hashChanged);
    };
  }, []);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Container, {
      children: /*#__PURE__*/_jsx(BreadCrumbContainer, {
        children: /*#__PURE__*/_jsx(BreadCrumb, {})
      })
    }), /*#__PURE__*/_jsxs(Section, {
      className: "d-none d-md-block",
      mb: "small",
      bg: "warning",
      py: "large",
      children: [/*#__PURE__*/_jsx(Col, {
        xs: 12,
        md: 6,
        children: /*#__PURE__*/_jsx(Typography, {
          type: "heading-1",
          children: heroSection.title
        })
      }), /*#__PURE__*/_jsx("div", {
        className: "position-absolute",
        style: {
          background: "url(".concat(heroSection.image.src, ")"),
          top: 0,
          left: '50%',
          width: '50%',
          height: '100%',
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'cover'
        }
      })]
    }), /*#__PURE__*/_jsx("div", {
      className: "d-md-none",
      children: /*#__PURE__*/_jsxs(Section, {
        mb: "small",
        bg: "warning",
        py: "large",
        children: [/*#__PURE__*/_jsx(Typography, {
          type: "heading-1",
          children: heroSection.title
        }), /*#__PURE__*/_jsx(Image, {
          image: heroSection.image
        })]
      })
    }), emailSection ? /*#__PURE__*/_jsxs(Section, {
      mb: "small",
      className: "align-items-center",
      children: [/*#__PURE__*/_jsx(Col, {
        xs: 12,
        lg: 5,
        children: /*#__PURE__*/_jsx(Typography, {
          type: "heading-4",
          className: "mb-300 mb-lg-0",
          children: emailSection.title
        })
      }), /*#__PURE__*/_jsx(Col, {
        xs: 12,
        sm: 8,
        md: 6,
        lg: 4,
        className: "offset-lg-1",
        children: /*#__PURE__*/_jsx(Form.Control, {
          className: "mb-200 mb-sm-0",
          placeholder: emailSection.placeholderText,
          onChange: function onChange(event) {
            return setEmailField(event.target.value);
          },
          value: emailField,
          type: "text"
        })
      }), /*#__PURE__*/_jsxs(Col, {
        xs: 9,
        sm: 4,
        md: 3,
        lg: 2,
        children: [/*#__PURE__*/_jsx(Cta, {
          className: "d-block d-sm-none",
          iconPosition: "end",
          href: signupUrl,
          children: emailSection.ctaText
        }), /*#__PURE__*/_jsx(Cta, {
          className: "w-100 d-none d-sm-block",
          iconPosition: "end",
          href: signupUrl,
          children: emailSection.ctaText
        })]
      })]
    }) : null, /*#__PURE__*/_jsxs(Section, {
      mb: "large",
      children: [/*#__PURE__*/_jsx(Col, {
        xs: 12,
        lg: 4,
        xl: 3,
        className: "ps-lg-0",
        children: getSidebarNav()
      }), /*#__PURE__*/_jsx(Col, {
        xs: 12,
        lg: 8,
        xl: 7,
        className: "ps-lg-300 ps-xl-600 pe-lg-0",
        children: currentNavItem !== null && currentNavItem !== void 0 && currentNavItem.content ? /*#__PURE__*/_jsx(RichTextRenderer, {
          document: currentNavItem.content
        }) : null
      })]
    }), readMoreSection !== null && readMoreSection !== void 0 && readMoreSection.title ? /*#__PURE__*/_jsx(ReadMore, _objectSpread({}, readMoreSection)) : null, othersSection !== null && othersSection !== void 0 && othersSection.title ? /*#__PURE__*/_jsx(OtherSolutions, _objectSpread({}, othersSection)) : null, /*#__PURE__*/_jsx(FooterSection, _objectSpread({}, footerSection))]
  });
};

export default SeoInfoPage;
export { SeoInfoPage };